import { render, staticRenderFns } from "./NoDataAvailable.vue?vue&type=template&id=edd13d90&v-slot%3Ano-data=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./NoDataAvailable.vue?vue&type=script&lang=js&"
export * from "./NoDataAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports